// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__YBBTN","mainNav":"Layout_mainNav__9ocV9","mainContent":"Layout_mainContent__s-mrP","inner":"Layout_inner__nhayT"};